import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {AuthService, CountriesListService, UserVO} from 'common-domain';
import {TldManagerUserService} from '../../user/services/tld-manager-user.service';

@Component({
  selector: 'sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss']
})
export class SignUpComponent implements OnInit {
  resetPasswordView = true;
  user: UserVO = {};


  constructor(private route: ActivatedRoute,
              private authService: AuthService,
              private userService: TldManagerUserService,
              private countriesListService: CountriesListService) {
  }

  ngOnInit() {
    this.authService.logoutClientSide();
    if (!this.route.snapshot || !this.route.snapshot.paramMap) {
      this.goHome();
    } else {
      const token = this.route.snapshot.paramMap.get('token');
      this.authService.validateTokenAndStoreAttributes(token).then(result => {
        this.countriesListService.load();
      }).catch(error => {
        this.goHome();
      });
    }
  }

  resetPasswordCompleted(completed: boolean) {
    if (completed) {
      this.userService.getCurrentUserFromHeaderToken().subscribe(user => {
        this.user = user;
      }, error => {
        console.log(error);
      }, () => {
        this.resetPasswordView = false;
      });
    } else {
      this.authService.logout();
    }
  }

  completeSignUp() {
    this.authService.logout('Signup complete', true);
  }

  goHome() {
    this.authService.redirectToHome('Token Invalid/Expired', false);
  }
}
